import React, { Component } from 'react';
import SideMenu from '../admin/SideMenu';
import TopMenu from '../admin/TopBar';
import { base } from '../../base';
import '../../styles/css/AdminMain.css';
import swal from 'sweetalert2';

// Admin page for managing the leaderboard. Surfaces the public /leaderboard URL
// and lets admins maintain the list of additional blocked words that the
// updateLeaderboard Cloud Function uses to censor display names.
class SetUpScoreboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scoreboardSettings: {},
            loading: true
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.scoreboardSettingsRef = base.bindToState('scoreboardSettings', {
            context: this,
            state: 'scoreboardSettings'
        });
        this.setState({ loading: false });
    }

    componentWillUnmount() {
        base.removeBinding(this.scoreboardSettingsRef);
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const scoreboardSettingsCopy = this.state.scoreboardSettings || {};
        scoreboardSettingsCopy[target.name] = value;
        this.setState({ scoreboardSettings: scoreboardSettingsCopy });
    }

    handleSubmit(event) {
        event.preventDefault();
        const vm = this;
        const scoreboardSettings = this.state.scoreboardSettings || {};
        this.setState({ loading: true });
        base.post('scoreboardSettings/', {
            data: { otherBlockedNames: scoreboardSettings.otherBlockedNames || "" },
            then(err) {
                vm.setState({ loading: false });
                if (!err) {
                    swal({
                        title: 'Scoreboard Settings Updated!',
                        type: 'success',
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: true,
                        timer: 10000
                    });
                } else {
                    swal({
                        title: 'There was some error!',
                        text: 'Try again and if the problem persists try logging out and logging back in',
                        type: 'error',
                        confirmButtonText: 'Ok'
                    });
                }
            }
        });
    }

    render() {
        const scoreboardSettings = this.state.scoreboardSettings || {};
        const gameLink = (process.env.REACT_APP_FAN_LINK || "").replace(/\/+$/, "");
        const scoreboardLink = window.location.origin.replace(/\/+$/, "") + "/scoreboard";
        const leaderboardLink = gameLink ? gameLink + "/leaderboard" : "";
        return (
            <div className="admin-wrapper">
                <div className="loading-screen" style={{ display: this.state.loading ? 'block' : 'none' }}/>
                <SideMenu/>
                <TopMenu/>
                <div className="admin-main-panel">
                    <div className="row" style={{ width: '100%' }}>
                        <div className="col-md-11">
                            <p className="admin-header-text" style={{ marginTop: '0px', marginBottom: '5px' }}>Game link: <span style={{ fontSize: '20px' }}>{gameLink}</span></p>
                            <p className="admin-header-text" style={{ marginTop: '0px', marginBottom: '5px' }}>Scoreboard link: <span style={{ fontSize: '20px' }}>{scoreboardLink}</span></p>
                            <p className="admin-header-text" style={{ marginTop: '0px' }}>Leaderboard link: <span style={{ fontSize: '20px' }}>{leaderboardLink}</span></p>
                        </div>
                    </div>
                    <div className="container-out">
                        <div className="admin-form-box">
                            <form onSubmit={this.handleSubmit} id="create-game-form">
                                <button className="btn btn-primary btn-lg update-button" id="submitButton" style={{ marginBottom: '20px' }}><span className="fa fa-arrow-circle-o-up"/> Update</button>
                                <div className="form-group">
                                    <label htmlFor="otherBlockedNames">Additional Blocked Words</label>
                                    <p style={{ fontSize: '10px', color: 'grey', fontFamily: 'Open Sans' }}>These words will be asterisked out (****), separate each word with a space</p>
                                    <textarea id="otherBlockedNames" name="otherBlockedNames" className="form-control" value={scoreboardSettings.otherBlockedNames || ""} onChange={this.handleChange}/>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SetUpScoreboard;
